import { createSlice } from "@reduxjs/toolkit";
import { sallerLogin, sallerProfile } from "./thunk";

const initialState = {
  saller: null,
  token: null,
  profile: null,
  isAuthenticated: false,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.saller = null;
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      localStorage.removeItem("adminAuth");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sallerLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sallerLogin.fulfilled, (state, action) => {
        state.saller = action.payload.user;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        state.loading = false;
        localStorage.setItem(
          "adminAuth",
          JSON.stringify({
            user: action.payload.user,
            token: action.payload.token,
          })
        );
      })
      .addCase(sallerLogin.rejected, (state, action) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.error = action.payload || "Login failed";
      })

      .addCase(sallerProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sallerProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload?.data || [];
      })
      .addCase(sallerProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
